import { Component, Input, OnChanges, OnInit } from '@angular/core';
import { EChartsOption } from 'echarts';
import {
	THEME_COLOR_MAIN,
	THEME_COLOR_GREEN,
	THEME_COLOR_VIOLET
} from 'src/app/core/services/constant/constants.service';
import { FacadeService } from 'src/app/core/services/facade.service';

@Component({
	selector: 'app-satisfaction-unassigned',
	templateUrl: './satisfaction-unassigned.component.html',
	styleUrls: ['./satisfaction-unassigned.component.scss']
})
export class SatisfactionUnassignedComponent implements OnChanges {
	@Input() unassignedStats: any;
	@Input() globalStats?: any;
	@Input() lsfStats?: any;
	@Input() lpcStats?: any;
	@Input() pdnStats?: any;
	@Input() oralStats?: any;

	satisfactionRate = 0.0;
	satisfactionRateLpc = 0.0;
	satisfactionRateLds = 0.0;
	satisfactionRatepdn = 0.0;
	satisfactionRateOral = 0.0;
	satisfactionRateSAAD = 0.0;

	chartOptionSatisfactionLSF: EChartsOption;
	chartOptionSatisfactionLPC: EChartsOption;
	chartOptionSatisfactionPDN: EChartsOption;
	chartOptionSatisfactionOral: EChartsOption;
	chartOptionSatisfactionSAAD: EChartsOption;

	isSESSAD = false;
	isSAAD = false;
	isSSIAD = false;

	constructor(private facade: FacadeService) {
		this.isSESSAD = this.facade.dataStorageService.isSESSAD();
		this.isSAAD = this.facade.dataStorageService.isSAAD();
		this.isSSIAD = this.facade.dataStorageService.isSSIAD();
	}

	// ngOnInit(): void {}

	ngOnChanges(changes: any): void {
		if (isNaN(this.unassignedStats)) {
			this.updateSatisfactionRate();
		}
	}

	updateSatisfactionRate() {
		if (
			this.isSESSAD &&
			isNaN(this.lpcStats) &&
			isNaN(this.lsfStats) &&
			isNaN(this.pdnStats) &&
			isNaN(this.oralStats)
		) {
			if (this.lpcStats && this.lpcStats.numberFormation > 0) {
				let rateLpc: number =
					1 -
					this.unassignedStats.numberUnassignedMissionLpc /
						this.lpcStats.numberFormation;
				rateLpc = rateLpc <= 0 ? 0 : rateLpc;
				this.satisfactionRateLpc = 100.0 * rateLpc;
			}

			if (this.lsfStats && this.lsfStats.numberFormation > 0) {
				let rateLds: number =
					1 -
					this.unassignedStats.numberUnassignedMissionLsf /
						this.lsfStats.numberFormation;
				rateLds = rateLds <= 0 ? 0 : rateLds;
				this.satisfactionRateLds = 100.0 * rateLds;
			}

			if (this.pdnStats && this.pdnStats.numberFormation > 0) {
				let ratepdn: number =
					1 -
					this.unassignedStats.numberUnassignedMissionPdn /
						this.pdnStats.numberFormation;
				ratepdn = ratepdn <= 0 ? 0 : ratepdn;
				this.satisfactionRatepdn = 100.0 * ratepdn;
			}

			if (this.oralStats && this.oralStats.numberFormation > 0) {
				let rateOral: number =
					1 -
					this.unassignedStats.numberUnassignedMissionOral /
						this.oralStats.numberFormation;
				rateOral = rateOral <= 0 ? 0 : rateOral;
				this.satisfactionRateOral = 100.0 * rateOral;
			}

			this.chartOptionSatisfactionLPC = {
				title: [
					{
						text: this.satisfactionRateLpc.toFixed(1) + '%',
						left: 'center',
						top: '32%',
						textStyle: {
							color: THEME_COLOR_MAIN
						}
					},
					{
						text: 'LPC',
						left: 'center',
						textStyle: {
							color: THEME_COLOR_MAIN
						}
					}
				],
				tooltip: {
					show: false
				},
				calculable: true,
				series: [
					{
						name: 'LPC',
						center: ['50%', '35%'],
						data: [
							{
								value: this.satisfactionRateLpc,
								itemStyle: { color: THEME_COLOR_GREEN },
								name: 'Formations LPC assignées'
							},
							{
								value: 100 - this.satisfactionRateLpc,
								itemStyle: { color: '#FFFFFF' },
								name: 'Formations LPC non assignées'
							}
						],
						label: {
							show: false
						},
						stillShowZeroSum: false,
						type: 'pie',
						radius: ['55%', '85%'],
						emphasis: {
							scale: false
						}
					}
				]
			};
			this.chartOptionSatisfactionLSF = {
				title: [
					{
						text: this.satisfactionRateLds.toFixed(1) + '%',
						left: 'center',
						top: '32%',
						textStyle: {
							color: THEME_COLOR_MAIN
						}
					},
					{
						text: 'LSF',
						left: 'center',
						textStyle: {
							color: THEME_COLOR_MAIN
						}
					}
				],
				tooltip: {
					show: false
				},
				calculable: true,
				series: [
					{
						name: 'LSF',
						center: ['50%', '35%'],
						data: [
							{
								value: this.satisfactionRateLds,
								itemStyle: { color: THEME_COLOR_GREEN },
								name: 'Formations LSF assignées'
							},
							{
								value: 100 - this.satisfactionRateLds,
								itemStyle: { color: '#FFFFFF' },
								name: 'Formations LSF non assignées'
							}
						],
						label: {
							show: false
						},
						stillShowZeroSum: false,
						type: 'pie',
						radius: ['55%', '85%'],
						emphasis: {
							scale: false
						}
					}
				]
			};

			this.chartOptionSatisfactionPDN = {
				title: [
					{
						text: this.satisfactionRatepdn.toFixed(1) + '%',
						left: 'center',
						top: '32%',
						textStyle: {
							color: THEME_COLOR_MAIN
						}
					},
					{
						text: 'Prise de notes',
						left: 'center',
						textStyle: {
							color: THEME_COLOR_MAIN
						}
					}
				],
				tooltip: {
					show: false
				},
				calculable: true,
				series: [
					{
						name: 'LPC',
						center: ['50%', '35%'],
						data: [
							{
								value: this.satisfactionRatepdn,
								itemStyle: { color: THEME_COLOR_GREEN },
								name: 'Formations Prise de notes assignées'
							},
							{
								value: 100 - this.satisfactionRatepdn,
								itemStyle: { color: '#FFFFFF' },
								name: 'Formations Prise de notes non assignées'
							}
						],
						label: {
							show: false
						},
						stillShowZeroSum: false,
						type: 'pie',
						radius: ['55%', '85%'],
						emphasis: {
							scale: false
						}
					}
				]
			};

			this.chartOptionSatisfactionOral = {
				title: [
					{
						text: this.satisfactionRateOral.toFixed(1) + '%',
						left: 'center',
						top: '32%',
						textStyle: {
							color: THEME_COLOR_VIOLET
						}
					},
					{
						text: 'Oral',
						left: 'center',
						textStyle: {
							color: THEME_COLOR_VIOLET
						}
					}
				],
				tooltip: {
					show: false
				},
				calculable: true,
				series: [
					{
						name: 'Oral',
						center: ['50%', '35%'],
						data: [
							{
								value: this.satisfactionRateOral,
								itemStyle: { color: THEME_COLOR_VIOLET },
								name: 'Formations Oral assignées'
							},
							{
								value: 100 - this.satisfactionRateOral,
								itemStyle: { color: '#FFFFFF' },
								name: 'Formations Oral non assignées'
							}
						],
						label: {
							show: false
						},
						stillShowZeroSum: false,
						type: 'pie',
						radius: ['55%', '85%'],
						emphasis: {
							scale: false
						}
					}
				]
			};
		} else if (this.isSAAD) {
			if (this.globalStats && this.globalStats.numberFormation > 0) {
				let rateSAAD: number =
					1 -
					this.unassignedStats.numberUnassignedMission /
						this.globalStats.numberFormation;
				rateSAAD = rateSAAD <= 0 ? 0 : rateSAAD;
				this.satisfactionRateSAAD = 100.0 * rateSAAD;

				this.chartOptionSatisfactionSAAD = {
					title: [
						{
							text: this.satisfactionRateSAAD.toFixed(1) + '%',
							left: 'center',
							top: '32%',
							textStyle: {
								color: THEME_COLOR_MAIN
							}
						},
						{
							text: 'Aide à domicile',
							left: 'center',
							textStyle: {
								color: THEME_COLOR_MAIN
							}
						}
					],
					tooltip: {
						show: false
					},
					calculable: true,
					series: [
						{
							name: 'Aide à domicile',
							center: ['50%', '35%'],
							data: [
								{
									value: this.satisfactionRateSAAD,
									itemStyle: { color: THEME_COLOR_GREEN },
									name: 'Prestations assignées'
								},
								{
									value: 100 - this.satisfactionRateSAAD,
									itemStyle: { color: '#FFFFFF' },
									name: 'Prestations non assignées'
								}
							],
							label: {
								show: false
							},
							stillShowZeroSum: false,
							type: 'pie',
							radius: ['55%', '85%'],
							emphasis: {
								scale: false
							}
						}
					]
				};
			}
		}
	}
}
